import {
	AuthField,
	AuthFieldIcon,
	AuthInput,
	AuthLabel,
} from '../../authModal.styles';

const IconMail = () => (
	<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
		<rect
			x="3.5"
			y="5.5"
			width="17"
			height="13"
			rx="2.5"
			stroke="currentColor"
			strokeWidth="1.5"
		/>
		<path
			d="m5 8 7 5.5L19 8"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

const AuthEmailField = ({
	email,
	onEmailChange,
	isAuthPending,
	isAuthSuccess,
	translations,
}) => (
	<AuthField>
		<AuthLabel htmlFor="auth-email">
			{translations.emailLabel || 'Email Address'}
		</AuthLabel>
		<AuthFieldIcon>
			<IconMail />
		</AuthFieldIcon>
		<AuthInput
			id="auth-email"
			type="email"
			placeholder={translations.emailPlaceholder || 'enter your email'}
			value={email}
			onChange={(event) => onEmailChange(event.target.value)}
			required
			$withIcon
			disabled={isAuthPending || isAuthSuccess}
		/>
	</AuthField>
);

export default AuthEmailField;
